import script from "./Iframe-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./Iframe-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./Iframe-wrap.vue?vue&type=style&index=0&id=2ec3f64a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec3f64a"]])

export default __exports__